/**
 * The navigation drawer entry to highlight for a route: the most specific entry whose path is the
 * route's path or one of its parents.
 *
 * Vue Router's own inclusive matching highlights every entry that is a parent of the route, so an
 * entry nested under another one (RENO Schnellprüfung at `/main/admin/renoReview` under IRES Admin at
 * `/main/admin`) lit both. Picking the longest match keeps the parent lit on its pages that have no
 * entry of their own (Testberichte under IRES Admin, a project under Projekte) and hands the
 * highlight to the nested entry on its own pages.
 *
 * @param routePath the current route path, without query or hash (`$route.path`).
 * @param navActions the paths of the drawer entries.
 * @returns the path of the entry to highlight, or `null` when none matches.
 */
export function getActiveNavAction(routePath: string, navActions: string[]): string | null {
  let best: string | null = null;

  for (const action of navActions) {
    const matches = routePath === action || routePath.startsWith(action + "/");

    if (matches && (best === null || action.length > best.length)) {
      best = action;
    }
  }

  return best;
}
